import React from 'react';
import { IconButton, Badge, Box } from '@mui/material';
import { motion } from 'framer-motion';
import CycloneIcon from '@mui/icons-material/Cyclone';

const TyphoonToggleIcon = ({ disabled = false }) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CycloneIcon
                fontSize="large"
                htmlColor={disabled ? '#555' : '#757575'} // OFF時は暗めに
                sx={{
                    width: 28,
                    height: 28,
                    filter: disabled ? 'brightness(0.5)' : 'none', // さらに暗くする
                }}
            />
            {disabled && (
                <motion.svg
                    viewBox="0 0 24 24"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        pointerEvents: 'none',
                    }}
                >
                    <motion.line
                        x1="4"
                        y1="20"
                        x2="20"
                        y2="4"
                        stroke="#fff" // 明るめの線で強調
                        strokeWidth="2"
                        strokeLinecap="round"
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: 1 }}
                        transition={{ duration: 0.3 }}
                    />
                </motion.svg>
            )}
        </Box>
    );
};

const TyphoonButton = (props) => {
    // selectを切り替える関数
    const toggleSelectTyphoon = () => {
        console.log('toggleSelectTyphoon', props.index)
        props.setTyphoonLayer((prev) =>
            prev.map((t, i) =>
                i === props.index ? { ...t, select: !t.select } : t
            )
        );
    };
    return (
        <IconButton
            onClick={toggleSelectTyphoon}
            sx={{
                position: 'absolute',
                width: '29px',
                height: '29px',
                top: props.top,
                right: '10px',
                zIndex: 500,
                padding: '2px',
                border: '1px solid rgba(0, 0, 0, 0.3)',
                borderRadius: '5px',
                backgroundColor: props.isShowTyphoon ? 'white' : '#9b9b9b',
                '&:hover': {
                    backgroundColor: props.isShowTyphoon ? 'rgb(243, 243, 243)' : '#9b9b9b',
                },
            }}

        >
            <Badge
                badgeContent={props.number}
                overlap="circular"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                sx={{
                    '& .MuiBadge-badge': {
                        backgroundColor: props.isShowTyphoon ? '#fff' : '#9b9b9b',
                        color: '#000',
                        fontWeight: 'bold',
                        fontSize: '0.7rem',
                        minWidth: '18px',
                        height: '18px',
                        border: '1px solid #999',
                        borderRadius: '50%',
                        boxShadow: '0 0 2px rgba(0,0,0,0.25)',
                    },
                }}
            >
                {props.isShowTyphoon
                    ? <TyphoonToggleIcon disabled={false} />
                    : <TyphoonToggleIcon disabled={true} />
                }
            </Badge>
        </IconButton>
    );
}
export default TyphoonButton;
